import { render, staticRenderFns } from "./EnderecoOrdemServico.vue?vue&type=template&id=6c5a342a"
import script from "./EnderecoOrdemServico.vue?vue&type=script&lang=js"
export * from "./EnderecoOrdemServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports